import { render, staticRenderFns } from "./PropositionForm.vue?vue&type=template&id=4497a964"
import script from "./PropositionForm.vue?vue&type=script&lang=ts"
export * from "./PropositionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports